import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref, watch} from "vue";
import "./Spoiler.scss";


export default /*#__PURE__*/_defineComponent({
  __name: 'Spoiler',
  setup(__props) {

let opened = ref<boolean>(false);
let body = ref<HTMLElement | null>(null);

watch(opened, () => {

	if(body.value){

		let scrollHeight = body.value.scrollHeight;
		let offsetHeight = body.value.offsetHeight;

		body.value.style.height = opened.value
			? (scrollHeight + 'px')
			: '0px';

	}

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spoiler", {'spoiler--opened' : _unref(opened)}])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "spoiler__button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(opened) //@ts-ignore
 ? opened.value = !_unref(opened) : opened = !_unref(opened)))
    }, [
      _renderSlot(_ctx.$slots, "button", { opened: _unref(opened) })
    ]),
    _createElementVNode("div", {
      class: "spoiler__body",
      ref_key: "body",
      ref: body,
      style: {"height":"0"}
    }, [
      _renderSlot(_ctx.$slots, "body", { opened: _unref(opened) })
    ], 512)
  ], 2))
}
}

})